import React, { Fragment } from 'react';
import walkingaccess from '../../../../../images/walkingaccess.png';
import '../../driverFaq.css';

const WalkingAccess = () => (
  <Fragment>
    <p>
      Follow the signage to the public parking elevator for direct access
      to the parking lot. Autzu EV vehicles are parked on P4 (Level D). The
      elevator is accessible 24/7 and no fob is required.
    </p>
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={walkingaccess} className="walking-image" />
    </div>
    <br />
  </Fragment>
);

export default WalkingAccess;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingHub/King/WalkingAccess.js